import React, { useState, useEffect } from "react";
import { useNavigate ,useParams} from "react-router-dom";
import { Link } from "react-router-dom";
import { Table, Button, Row, Col, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Message from "../components/Message";
import Loader from "../components/Loader";
import Paginate from "../components/Paginate";
import {
  listProducts,
  deleteProduct,
  createProduct,
} from "../actions/productActions";
import { PRODUCT_CREATE_RESET } from "../constants/productConstans";
import axios from "axios";

const ProductListScreen = () => {

  const { pageNumber } = useParams() || 1;

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const productList = useSelector((state) => state.productList);
  const { loading, error, products, page,pages } = productList;

  const productDelete = useSelector((state) => state.productDelete);
  const {
    loading: loadingDelete,
    error: errorDelete,
    success: successDelete,
  } = productDelete;

  const productCreate = useSelector((state) => state.productCreate);
  const {
    loading: loadingCreate,
    error: errorCreate,
    success: sucessCreate,
    product: createdProduct,
  } = productCreate;

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  // Store config state
  const [shippingCost, setShippingCost] = useState("");
  const [freeShippingThreshold, setFreeShippingThreshold] = useState("");
  const [configMsg, setConfigMsg] = useState(null);
  const [configError, setConfigError] = useState(null);

  useEffect(() => {
    axios.get("/api/config").then((res) => {
      setShippingCost(res.data.shippingCost);
      setFreeShippingThreshold(res.data.freeShippingThreshold);
    });
  }, []);

  const saveConfigHandler = async (e) => {
    e.preventDefault();
    setConfigMsg(null);
    setConfigError(null);
    try {
      const config = { headers: { Authorization: `Bearer ${userInfo.token}` } };
      await axios.put(
        "/api/config",
        { shippingCost: Number(shippingCost), freeShippingThreshold: Number(freeShippingThreshold) },
        config
      );
      setConfigMsg("Configuración guardada.");
    } catch (err) {
      setConfigError(err?.response?.data?.message || "Error al guardar.");
    }
  };

  useEffect(() => {
    dispatch({ type: PRODUCT_CREATE_RESET });

    if (!userInfo || !userInfo.isAdmin) {
      navigate("/login");
    }

    if (sucessCreate) {
      navigate(`/admin/product/${createdProduct._id}/edit`);
    } else {
      dispatch(listProducts('', pageNumber));
    }
  }, [
    dispatch,
    navigate,
    userInfo,
    successDelete,
    loadingDelete,
    errorDelete,
    sucessCreate,
    createdProduct,
    pageNumber,
  ]);

  const deleteHandler = (id) => {
    if (window.confirm("Are you sure?")) {
      //delete products
      dispatch(deleteProduct(id));
    }
  };

  const createProductHandler = (product) => {
    //create product
    dispatch(createProduct());
  };

  return (
    <>
      <Row className="align-items-center">
        <Col>
          <h1>Products</h1>
        </Col>
        <Col className="text-right">
          <Button className="my-3" onClick={createProductHandler}>
            <i className="fas fa-plus"></i> Create Product
          </Button>
        </Col>
      </Row>
      {/* Store config panel */}
      <div style={{ border: "1px solid rgba(128,128,128,0.3)", borderRadius: 6, padding: "16px 20px", marginBottom: 24 }}>
        <h5 style={{ marginBottom: 12, fontSize: 13, fontWeight: 600, letterSpacing: "0.12em", textTransform: "uppercase", opacity: 0.7 }}>Configuración de envío</h5>
        <Form onSubmit={saveConfigHandler}>
          <Row className="align-items-end">
            <Col xs={12} sm={4}>
              <Form.Group controlId="shippingCost">
                <Form.Label style={{ fontSize: 13 }}>Costo de envío ($)</Form.Label>
                <Form.Control
                  type="number"
                  min="0"
                  value={shippingCost}
                  onChange={(e) => setShippingCost(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col xs={12} sm={4}>
              <Form.Group controlId="freeShippingThreshold">
                <Form.Label style={{ fontSize: 13 }}>Envío gratis a partir de ($)</Form.Label>
                <Form.Control
                  type="number"
                  min="0"
                  value={freeShippingThreshold}
                  onChange={(e) => setFreeShippingThreshold(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col xs={12} sm={4}>
              <Button type="submit" variant="primary" style={{ marginTop: 8 }}>
                Guardar
              </Button>
            </Col>
          </Row>
        </Form>
        {configMsg && <Message variant="success" style={{ marginTop: 8 }}>{configMsg}</Message>}
        {configError && <Message variant="danger" style={{ marginTop: 8 }}>{configError}</Message>}
      </div>

      {loadingDelete && <Loader></Loader>}
      {errorDelete && <Message variant="danger">{errorDelete}</Message>}
      {loadingCreate && <Loader></Loader>}
      {errorCreate && <Message variant="danger">{errorCreate}</Message>}
      {loading ? (
        <Loader></Loader>
      ) : error ? (
        <Message variant="danger">{error}</Message>
      ) : products ? (
        <>
        <Table striped bordered hover responsive className="table-sm">
          <thead>
            <tr>
              <th>ID</th>
              <th>NAME</th>
              <th>PRICE</th>
              <th>CATEGORY</th>
              <th>BRAND</th>
              <th>STOCK</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {products.map((product) => (
              <tr key={product._id}>
                <td>{product._id}</td>
                <td>{product.name}</td>

                <td>${product.price}</td>

                <td>{product.category}</td>

                <td>{product.brand}</td>

                <td>
                  {product.countInStock > 0 ? ( 
                    product.countInStock
                  ) : (
                    <i className="fas fa-times" style={{ color: "red" }}></i>
                  )}
                </td>

                <td>
                  <Link to={`/admin/product/${product._id}/edit`}>
                    <Button variant="light" className="btn-sm">
                      <i className="fas fa-edit"></i>
                    </Button>
                  </Link>

                  <Button
                    variant="danger"
                    className="btn-sm"
                    onClick={() => deleteHandler(product._id)}
                  >
                    <i className="fas fa-trash"></i>
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        <Paginate pages={pages} page={page} isAdmin={true}></Paginate>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default ProductListScreen;
